import styled from '@emotion/styled'
import { Link as GatsbyLink, graphql, navigate, withPrefix } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import GlobalCss from '../components/CustomStyles/GlobalStyles'

import {
  Accordion,
  Banner,
  Billboard,
  Brandy,
  Column,
  Columns,
  List,
  ListItem,
  PackageCard,
  SplitContent,
  Typography,
  useMapi,
  VariableContent,
} from '@leshen/gatsby-theme-leshen'

import { Dropdown, Stack } from '@leshen/ui'

import { Layout } from '@leshen/gatsby-theme-contentful'

import footer from '../components/Footer'
import header from '../components/Header'
import SeoCtaBar from '../components/SeoCtaBar'
import getFullStateName from '../utils/getFullStateName'

import PhoneCTA from '@leshen/gatsby-theme-leshen/src/components/PhoneCTA'

const City = ({ data }) => {
  const { City, FAQ_Group, Page_Path, State } = data.pageInfo.edges[0].node

  const State_Name = getFullStateName(State)

  const { rotatedNumber } = useMapi()

  const FaqQuestions = {
    1: [
      {
        title: `¿Hay servicio de DishLATINO TV en ${City}, ${State_Name}?`,
        content: (
          <div>
            <Typography>
              ¡Sí! Puedes encontrar DishLATINO TV en {City}, {State_Name}.
              ¡Descubre qué paquetes de TV de DishLATINO están disponibles en tu
              área hoy mismo!
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Cuánto cuestan los paquetes de DishLATINO Satellite TV en ${City}, ${State}?`,
        content: (
          <div>
            <Typography>
              Los paquetes de TV vía satélite de DishLATINO varían según el
              plan. Consulta los paquetes y precios de TV vía satélite e
              internet de DishLATINO en {City}, {State_Name}.
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Cómo puedo contactar a DishLATINO TV en ${City}, ${State}?`,
        content: (
          <div>
            <Typography>
              Puedes contactar a DishLATINO TV en {City}, {State_Name} llamando
              al <a href={`tel:${rotatedNumber}`}>{rotatedNumber}</a>
            </Typography>
          </div>
        ),
      },
      {
        title: `¿DishLATINO Network ofrece paquetes en ${City}, ${State}?`,
        content: (
          <div>
            <Typography>
              ¡Sí! DishLATINO Network ofrece paquetes en {City}, {State_Name}{' '}
              para que puedas obtener tanto internet como entretenimiento en tu
              hogar. Ahorra con los paquetes de DishLATINO Network.
            </Typography>
          </div>
        ),
      },
    ],
    2: [
      {
        title: `${City}, ${State_Name} ofrece servicio de DishLATINO Network?`,
        content: (
          <div>
            <Typography>
              ¡Sí! {City}, {State_Name} ofrece el servicio de DishLATINO Network
              en tu área. ¡Descubre qué paquetes de TV de DishLATINO Network
              están disponibles en tu área hoy mismo!
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Cuánto cuesta DishLATINO Network en ${City}, ${State}?`,
        content: (
          <div>
            <Typography>
              Dependiendo del paquete de TV que elijas, el costo de DishLATINO
              Network en {City}, {State_Name} puede variar. Compara los paquetes
              y precios de DishLATINO Network en {City}, {State_Name}.
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Cómo puedo contactar a DishLATINO Network en ${City}, ${State}?`,
        content: (
          <div>
            <Typography>
              Puedes contactar a DishLATINO Network en {City}, {State_Name}{' '}
              llamando al <a href={`tel:${rotatedNumber}`}>{rotatedNumber}</a>.
            </Typography>
          </div>
        ),
      },
      {
        title: `¿DishLATINO Network ofrece paquetes de TV e internet en ${City}, ${State}?`,
        content: (
          <div>
            <Typography>
              ¡Sí! DishLATINO Network ofrece paquetes de TV e internet en {City}
              , {State_Name}. Ahorra con paquetes de DishLATINO. Hoy mismo.
            </Typography>
          </div>
        ),
      },
    ],
    3: [
      {
        title: `¿Está disponible DishLATINO Network en ${City}, ${State_Name}?`,
        content: (
          <div>
            <Typography>
              ¡Sí! DishLATINO Network está disponible en {City}, {State_Name}.
              ¡Descubre qué planes de TV de DishLATINO Network están disponibles
              en tu área hoy mismo!
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Cuánto cuesta DishLATINO TV en ${City}, ${State}?`,
        content: (
          <div>
            <Typography>
              Los precios de DishLATINO TV varían según el plan. Compara los
              paquetes y precios de DishLATINO TV en {City}, {State_Name} hoy
              mismo.
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Cuál es el número de teléfono de DishLATINO Satellite en ${City}, ${State_Name}?`,
        content: (
          <div>
            <Typography>
              El número de teléfono de DishLATINO Satellite en {City},{' '}
              {State_Name} es{' '}
              <a href={`tel:${rotatedNumber}`}>{rotatedNumber}</a>.
            </Typography>
          </div>
        ),
      },
      {
        title: `¿DishLATINO TV en ${City}, ${State} ofrece paquetes con internet?`,
        content: (
          <div>
            <Typography>
              ¡Sí! DishLATINO TV en {City}, {State_Name} se asocia con
              proveedores de internet para ofrecer internet y entretenimiento en
              tu hogar. Ahorra con{' '}
              <a href="https://latino.usdish.com/paquetes">
                https://latino.usdish.com/paquetes
              </a>{' '}
              hoy mismo.
            </Typography>
          </div>
        ),
      },
    ],
    4: [
      {
        title: `¿Puedo obtener DishLATINO TV en ${City}, ${State_Name}?`,
        content: (
          <div>
            <Typography>
              ¡Sí! Puedes obtener DishLATINO TV en {City}, {State_Name}.
              ¡Descubre qué planes de TV están disponibles en tu área hoy mismo!
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Cuánto cuestan los paquetes de DishLATINO TV en ${City}, ${State}?`,
        content: (
          <div>
            <Typography>
              Los precios de DishLATINO TV varían según el plan. Compara los
              paquetes y precios de TV de DishLATINO en {City}, {State_Name}.
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Cuál es el número de DishLATINO Network en ${City}, ${State_Name}?`,
        content: (
          <div>
            <Typography>
              El número de teléfono de DishLATINO Network en {City},{' '}
              {State_Name} es{' '}
              <a href={`tel:${rotatedNumber}`}>{rotatedNumber}</a>.
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Puedo obtener internet con DishLATINO TV en ${City}, ${State}?`,
        content: (
          <div>
            <Typography>
              ¡Sí! Puedes obtener internet con DishLATINO TV en {City},{' '}
              {State_Name} con un paquete. Ahorra con los paquetes de TV de
              DishLATINO Network hoy mismo.
            </Typography>
          </div>
        ),
      },
    ],
    5: [
      {
        title: `¿Está disponible DishLATINO Satellite TV en ${City}, ${State_Name}`,
        content: (
          <div>
            <Typography>
              ¡Sí! Puedes encontrar DishLATINO Satellite TV en {City},{' '}
              {State_Name}. ¡Descubre qué paquetes de TV vía satélite están
              disponibles en tu área hoy mismo!
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Cuánto cuesta DishLATINO Satellite TV en ${City}, ${State}?`,
        content: (
          <div>
            <Typography>
              Si bien los precios no varían según la ciudad, sí varían según el
              paquete de TV. Consulta los paquetes de TV vía satélite de
              DishLATINO en {City}, {State_Name}.
            </Typography>
          </div>
        ),
      },
      {
        title: `¿Cuál es el número de teléfono de DishLATINO TV en ${City}, ${State_Name}`,
        content: (
          <div>
            <Typography>
              El número de teléfono de DishLATINO TV en {City}, {State_Name} es{' '}
              <a href={`tel:${rotatedNumber}`}>{rotatedNumber}</a>.
            </Typography>
          </div>
        ),
      },
      {
        title: '¿Es posible obtener internet con DishLATINO TV?',
        content: (
          <div>
            <Typography>
              ¡Sí! Es absolutamente posible combinar internet con tu servicio de
              DishLATINO TV. Ahorra con paquetes de DishLATINO. Hoy mismo.
            </Typography>
          </div>
        ),
      },
    ],
  }

  const brandyPackageList = [
    'dn-dishlat-plus',
    'dn-dishlat-dos',
    'dn-dishlat-max',
  ]

  const packageList = brandyPackageList
    .map((packageId) =>
      data.allBrandyPackage.edges.find(
        ({ node }) => node.brandy_id === packageId
      )
    )
    .filter((node) => node)

  const cityDropdownData = data.cities.edges.map((current) => ({
    label: current.node.City,
    value: current.node.Page_Path,
  }))

  const layoutProps = {
    data: {
      contentfulPage: {
        header: header(),
        footer: footer(),
        seo: {
          title: `Cobertura de DishLATINO | ${rotatedNumber}`,
          description:
            'Si estás buscando un nuevo proveedor de TV, DishLATINO tiene paquetes de TV convenientes desde $54.99/mes y cobertura en todo el país',
          canonical: `https://latino.dish.com/cobertura${Page_Path}`,
          robots: 'index,follow',
        },
        path: Page_Path,
        promoCode: 'SAMPLEPROMO',
        ringPool: 'RINGPOOL123',
        spanish: true,
        customBreadCrumbs: null,
      },
      site: {
        siteMetadata: {
          siteURL: 'https://latino.dish.com/cobertura',
          siteName: 'Dishlatino',
          alternateName: 'Dishlatino',
          trailingSlash: 'never',
        },
      },
    },
    titleTemplate: `Servicios de DishLATINO Network con cobertura cerca de tí | ${rotatedNumber} | Paquetes de TV`,
    defaultRobots: 'follow,index',
    main: (
      <>
        <GlobalCss />
        <Billboard
          backgroundColor="midgray"
          variant="split"
          image={
            <StaticImage
              src="../images/lifestyle/family-with-popcorn.webp"
              alt=""
              placeholder="blurred"
              loading="eager"
            />
          }
          mobileImage={
            <StaticImage
              src="../images/lifestyle/family-with-popcorn.webp"
              alt=""
              placeholder="blurred"
              loading="eager"
            />
          }
          mainContent={
            <>
              <Typography variant="h1">
                DishLATINO en {City}, {State_Name}
              </Typography>
              <Typography variant="h4">
                <strong>
                  Descubre la disponibilidad de DishLATINO TV Satelital en tu
                  área hoy mismo.
                </strong>
              </Typography>
              <PhoneCTA color="primary">¡Llama ya!</PhoneCTA>
            </>
          }
        />

        <SeoCtaBar />

        <VariableContent
          mainContent={
            <>
              <Typography variant="h2">
                Paquetes de TV en {City}, {State_Name}
              </Typography>
              <Typography variant="body">
                Tu ciudad tiene acceso al mejor entretenimiento con DishLATINO.
                Conoce a continuación los paquetes disponibles en tu ciudad con
                precio fijo garantizado por 2 años y una confiabilidad de señal
                del 99% a nivel nacional.
              </Typography>
              <Typography variant="h4">
                <strong>Paquetes con precio fijo garantizado por 2 años</strong>
              </Typography>
            </>
          }
        >
          <Stack spacing="xxl">
            <Columns>
              {packageList.map((currentPackage) => (
                <PackageCard
                  packageData={{ ...currentPackage.node }}
                  key={currentPackage.node.brandy_id}
                  content={
                    <>
                      <PhoneCTA color="primary">Llama</PhoneCTA>
                    </>
                  }
                />
              ))}
            </Columns>
            <Brandy
              text={data.disclaimerOne.text}
              variant="legal"
              style={{
                textAlign: 'center',
              }}
            />
          </Stack>
        </VariableContent>

        <Banner
          backgroundColor="primary" // primary, secondary, etc
          image="" // <Image /> component
          disclaimer={false}
          className="canales-banner"
          module={
            <GatsbyLink
              to="https://my.dish.com/cms-files/channelcards/2023/0504/DishLATINO-CONUS.pdf"
              target="_blank"
            >
              Ver Canales
            </GatsbyLink>
          }
        />

        <SplitContent
          image={
            <StaticImage
              src="../images/lifestyle/soccer-player.webp"
              alt="Family laughing at show together"
              placeholder="blurred"
            />
          }
          mainContent={
            <>
              <Typography variant="h2">
                Vive los deportes con DishLATINO
              </Typography>
              <Typography variant="body">
                Además de ganar con tu equipo favorito, imagina tener acceso a
                múltiples ligas, canales y partidos, todo en un mismo lugar. Con
                DishLATINO, puedes disfrutar de una amplia selección de
                competencias internacionales, las mejores ligas y las últimas
                noticias deportivas que te apasionan con:
              </Typography>

              <List>
                <ListItem>
                  <Typography variant="body">MLB Extra Innings</Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body">ESPN Game Plan</Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body">NBA League Pass</Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body">NHL Center Ice</Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body">ESPN Full Court</Typography>
                </ListItem>
              </List>
              <Typography variant="body">
                Disfruta de los mejores momentos, desde la comodidad de tu
                sillón!
              </Typography>
              <PhoneCTA color="primary">¡Qué esperas, llama ya!</PhoneCTA>
            </>
          }
        />

        <SplitContent
          backgroundColor="light"
          image={
            <StaticImage
              src="../images/lifestyle/couple-watching-tv.webp"
              alt="Sports fans watching game"
              placeholder="blurred"
            />
          }
          mainContent={
            <>
              <Typography variant="h2">
                TV Latino en {City}, {State_Name}
              </Typography>
              <Typography variant="body">
                Aprovecha una gran variedad en entretenimiento con programas,
                series y telenovelas de toda Latinoamérica. Mantente conectado a
                tus raíces con DishLATINO y sus paquetes Plus, Dos y Max que te
                ofrecen combinaciones de programación en inglés y en español.
              </Typography>
            </>
          }
        />

        <VariableContent
          mainContent={
            <>
              <Typography variant="h2">
                Además en {State_Name} disfrutas de canales locales afiliados a:
              </Typography>
              <StaticImage
                src="../images/channels/channels.webp"
                alt=""
                placeholder="blurred"
              />
            </>
          }
          alignMainContent="Center"
        ></VariableContent>
        <VariableContent
          backgroundColor="midgray"
          mainContent={
            <>
              <Typography variant="h2">
                ¿Por qué obtener la red DishLATINO cerca de mí?
              </Typography>
              <Typography variant="body">
                Cámbiate a DishLATINO es sinónimo de disfrutar del mejor valor
                en entretenimiento sin la preocupación de aumentos de precio en
                los siguientes 2 años, tecnología galardonada en televisión
                satelital y el mejor servicio al cliente.
              </Typography>
            </>
          }
        >
          <Stack>
            <Columns cardStyled className="center-text info-cards">
              <Column
                style={{ paddingTop: '20px' }}
                image={
                  <StaticImage
                    src="../images/icons/bill.svg"
                    alt=""
                    placeholder="blurred"
                  />
                }
              >
                <Typography className="center-text" variant="h4">
                  <strong>
                    2 años de precio garantizado para tu servicio de TV
                  </strong>
                </Typography>
              </Column>
              <Column
                style={{ paddingTop: '20px' }}
                image={
                  <StaticImage
                    src="../images/icons/map-pin.svg"
                    alt=""
                    placeholder="blurred"
                  />
                }
              >
                <Typography className="center-text" variant="h4">
                  <strong>
                    La cobertura de DishLATINO llega donde muchos proveedores no
                    lo hacen
                  </strong>
                </Typography>
              </Column>
              <Column
                style={{ paddingTop: '20px' }}
                image={
                  <StaticImage
                    src="../images/icons/shield.svg"
                    alt=""
                    placeholder="blurred"
                  />
                }
              >
                <Typography
                  style={{ paddingTop: '20px' }}
                  className="center-text"
                  variant="h4"
                >
                  <strong>Garantía de una señal estable y confiable</strong>
                </Typography>
              </Column>
            </Columns>
          </Stack>
        </VariableContent>

        <SplitContent
          image={
            <StaticImage
              src="../images/lifestyle/dad-with-kid.webp"
              alt="dad with kid on computer"
              placeholder="blurred"
            />
          }
          mainContent={
            <>
              <Typography variant="h2">
                Paquetes de TV de DishLATINO Network e Internet
              </Typography>
              <Typography variant="body">
                En DishLATINO entendemos que buscas llevar solo lo mejor a tu
                hogar, es por eso que te ofrecemos entretenimiento de alta
                calidad a través de nuestro servicio de TV satelital. Además,
                nos asociamos con proveedores de Internet para que puedas
                solicitar Internet y TV juntos en una sola llamada,
                proporcionándote una solución integral para el hogar.
              </Typography>
              <PhoneCTA color="primary">¡Llame ya!</PhoneCTA>
            </>
          }
        />

        <VariableContent
          backgroundColor="dark"
          mainContent={
            <>
              <Typography variant="h2">
                ¿Estás buscando servicios de DishLATINO TV en {City},{' '}
                {State_Name}?
              </Typography>
              <Typography variant="body">
                ¡Buenas noticias! estás en un área con cobertura de servicios
                para DishLATINO. Diviértete con TV satelital confiable, relájate
                con un precio fijo garantizado por 2 años y vive la programación
                bilingüe y de gran variedad de canales en tu ciudad.
              </Typography>
              <Typography variant="body">
                Cuéntale a tus amigos y familiares que DishLATINO TV también
                está disponible en:
              </Typography>
              <Dropdown
                options={cityDropdownData}
                onChange={(e) => navigate(e.value)}
                placeholderText="Selecciona tu ciudad"
              />
              {cityDropdownData?.map((current) => (
                <StyledLink
                  href={withPrefix(current.value)}
                  key={current.value}
                >
                  {current.label}
                </StyledLink>
              ))}
            </>
          }
        ></VariableContent>

        <VariableContent>
          <Typography variant="h2">Preguntas frecuentes</Typography>
          <Stack spacing="xxl" alignMainContent="center">
            <Accordion items={FaqQuestions[FAQ_Group]} spanish />
          </Stack>
        </VariableContent>
      </>
    ),
    disableBreadcrumbs: false,
  }

  return <Layout {...layoutProps} />
}

export default City

const StyledLink = styled.a`
  display: none !important;
`

export const query = graphql`
  query CityPageQuery($pagePath: String, $stateAbbreviation: String) {
    allBrandyPackage {
      edges {
        node {
          brandy_id
          bullets {
            text
          }
          price {
            amount
            duration
          }
          brand_token
          name
          id
        }
      }
    }
    pageInfo: allDatasetManagerDishLatinoAoa(
      filter: { Page_Path: { eq: $pagePath } }
    ) {
      edges {
        node {
          City
          FAQ_Group
          Page_Path
          State
          Region
        }
      }
    }

    cities: allDatasetManagerDishLatinoAoa(
      filter: { State: { eq: $stateAbbreviation }, Area_Type: { eq: "city" } }
      sort: { City: ASC }
    ) {
      edges {
        node {
          City
          Page_Path
          FAQ_Group
          Region
        }
      }
    }
    disclaimerOne: brandyDisclaimer(
      brandy_id: { eq: "disclaimer-es-pricingpremuim" }
    ) {
      id
      text
    }
  }
`
